import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import { DarkModeContextProvider } from "./context/darkModeContext";
import logo from "./assets/images/logo tab.png";

(function setFavicons(src) {
  const head = document.head || document.getElementsByTagName("head")[0];

  [...head.querySelectorAll("link[rel*='icon'], link[rel='shortcut icon'], link[rel='mask-icon']")].forEach(n => n.remove());

  const createLink = (rel, type = null, sizes = null) => {
    const link = document.createElement("link");
    link.rel = rel;
    if (type) link.type = type;
    if (sizes) link.sizes = sizes;
    link.href = src;
    return link;
  };

  head.appendChild(createLink("icon", "image/png", "32x32"));
  head.appendChild(createLink("shortcut icon", "image/png", "16x16"));

  head.appendChild(createLink("icon", "image/png", "192x192"));
})(logo);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <DarkModeContextProvider>
        <App />
      </DarkModeContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);
